module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RechargeView.js"));
	}, "RechargeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RechargeView!./src/pages/Store/Wallet/Recharge/RechargeView.js
// module id = 1217
// module chunks = 431